import { IncentiveOfferOperationStatus } from 'modules/incentivesMarket/types';
import { IncentiveOfferOperationDetailContextType } from '../types/IncentiveOfferOperationDetailContextType';

export const incentiveOfferOperationDetailInitValue: IncentiveOfferOperationDetailContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      operation: null,
      incentiveOffer: null,
      operationReference: '',
      operationStatus: IncentiveOfferOperationStatus.PENDING,
      timelineSteps: [],
      buyerInfo: null,
      sellerInfo: null,
      isAdmin: false,
      isLoading: true,
      beneficiaryId: '',
      userDocumentRole: null,
      canPostComment: false,
    },
    actions: {
      handleGoBack: () => {},
      handleUpdateStatus: () => {},
      handleGoToOffer: () => {},
      handleRefreshOperation: async () => {},
      handleAddComment: async () => {},
      handleRemoveComment: async () => {},
    },
  };
